/**
 * Copyright © IMPACT Commerce AB. All rights reserved.
 * See COPYING.txt for license details.
 */

const SRC = 'https://chatbot-ui-virid-sigma.vercel.app/widget/truste-chatbot.min.js';
const TENANT_ID = '76724e63-74b7-42c0-8c88-4f66eb74ec21';

function loadChat() {
  if (window.TrusteChatbot?.isInitialized?.()) return;
  if (document.querySelector(`script[src="${SRC}"]`)) return;

  const script = document.createElement('script');
  script.src = SRC;
  script.async = true;
  script.setAttribute('data-auto-init', 'true');
  script.setAttribute('data-tenant-id', TENANT_ID);
  script.setAttribute('data-current-url', window.location.href);
  script.setAttribute('data-environment', 'prod');
  document.head.appendChild(script);
}

// Visitor accepts / saves preferences in the banner on this page
document.addEventListener('visitorConsentCollected', (event) => {
  if (event.detail?.preferencesAllowed) loadChat();
});

// Returning visitor who already consented.
// Not preferencesProcessingAllowed(): it returns true while the consent cookie is still missing
// (first visit, e.g. iOS incognito), which showed the chat before the banner was answered.
// The callback can report "already loaded" when the cookie banner loaded the API first; it is still usable then.
window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.2' }], () => {
  if (window.Shopify.customerPrivacy?.currentVisitorConsent().preferences === 'yes') loadChat();
});
